<main *ngIf="!fatura || !fatura.dueDate" class="fullheight">
  <p>
    <img src="assets/img/empty.png">
  </p>
  <h1>Fatura não disponível</h1>
</main>


<nav *ngIf="fatura && fatura.dueDate">

  <eae-bottom-sheet 
    [show]="showEscolhaPagamento" 
    title="Forma de pagamento" 
    [subtitle]="'Pague até o dia ' + dateStringToBrazil(fatura.dueDate)"
    (onClose)="setShowEscolhaPagamento(false)"
  >
    <div content>
      <ul class="agendaedu-list">
        <li (click)="tipoPagamento = 'fatura-pix'">
          <div class="agendaedu-list-content">
            <img src="assets/img/icons/pix.svg"> Via código Pix
          </div>
          <div>
            <input type="radio" [(ngModel)]="tipoPagamento" value="fatura-pix" style="width: 18px; height: 18px;" />
          </div>
        </li>
        <li (click)="tipoPagamento = 'fatura'">
          <div class="agendaedu-list-content">
            <img src="assets/img/icons/boleto.svg" width="30px"> Via boleto bancário
          </div>
          <div>
            <input type="radio" [(ngModel)]="tipoPagamento" value="fatura" style="width: 18px; height: 18px;" />
          </div>
        </li>
      </ul>

      <ae-buttons>
        <ae-buttons-button class="ae-buttons ae-buttons-rounded ae-button-select-modal" *ngIf="tipoPagamento != ''">
          <a href="/{{tipoPagamento}}/{{fatura.bankSliptId}}">Selecionar</a>
        </ae-buttons-button>
        <ae-buttons-button class="ae-buttons ae-buttons-rounded ae-buttons-disabled ae-button-select-modal" *ngIf="tipoPagamento == ''">
          <a>Selecionar</a>
        </ae-buttons-button>
      </ae-buttons>
    </div>
  </eae-bottom-sheet>

  <ae-buttons>
    <ae-buttons-button>
      <a (click)="setShowEscolhaPagamento(true)">Selecionar forma de pagamento</a>
    </ae-buttons-button>
  </ae-buttons>
</nav>
